import { Component, computed, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FormSubmission } from '@models';

const FORM_TYPE_LABEL: Record<FormSubmission['formType'], string> = {
  ConsentForm: 'Consent Form',
  SmartForm: 'Smart Form',
  IntakeForm: 'Intake Form',
};

@Component({
  selector: 'patient-portal-form-banner',
  templateUrl: './form-banner.component.html',
  imports: [MatIconModule],
})
export class FormBannerComponent {
  form = input<FormSubmission | null>(null);
  expanded = input<boolean>(false);

  fillForm = output<FormSubmission | null>();

  protected readonly dismissed = signal(false);

  formTypeLabel = computed(() => {
    const form = this.form();
    if (!form) return '';
    return FORM_TYPE_LABEL[form.formType] ?? '';
  });

  protected dismiss(): void {
    this.dismissed.set(true);
  }
}
